<script setup lang="ts">
import type { Content } from "@prismicio/client";

defineProps(getSliceComponentProps<Content.TextImageHorizontalSlice>());
</script>

<template>
  <Bounded
      as="section"
      y-padding="base"
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      :class="['pa-tih', 'pa-tih--' + slice.variation]"
  >
    <div class="pa-tih__grid">
      <!-- Text content -->
      <div class="pa-tih__content">
        <div v-if="slice.primary.eyebrow" class="pa-tih__content-eyebrow">
          {{ slice.primary.eyebrow }}
        </div>
        <div class="pa-tih__content-title">
          <PrismicRichText :field="slice.primary.title" />
        </div>
        <div class="pa-tih__content-description">
          <PrismicRichText :field="slice.primary.description" />
        </div>
      </div>

      <!-- Image -->
      <div class="pa-img-hover">
        <PrismicImage
            v-if="slice.primary.image?.url"
            :field="slice.primary.image"
            class="pa-tih__image"
        />
      </div>
    </div>
  </Bounded>
</template>
